import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { withTranslation } from "react-i18next";
import {
  AllRoles,
  getRoleById,
  AllRolesPermissions,
  UpdateRoles,
  CreateRoleDetails,
} from "../../Apis/roleCreationApi";
// import { getRoleById } from "../../Apis/loginApi";
import "./roleCreation.css";
import { toast } from "react-toastify";
import Loader from "../../Common/Loader/loader";
import isGHMC from "../../Common/helper/helpar";
import { ExportRolesExcel } from "./exportRoles";
import TableSkeleton from "../AllotedMaster/TableSkeleton";

const RoleCreation = ({ t }) => {
  const headers = ["roleName", "roleCode", "status", "actions"];
  const [lgShow, setLgShow] = useState(false);
  const [rolesData, setRolesData] = useState([]);
  const [editRoleData, setEditRoleData] = useState([]);
  const [currentMode, setcurrentMode] = useState("");
  const [toggleState, setToggleState] = useState({});
  const [permissions, setPermissions] = useState([]);
 const isProd = isGHMC();

  // Define a state variable to hold the color of the slider
  const [sliderColor, setSliderColor] = useState("switch_grey");
  const [formInput, setFormInput] = useState({
    roleId: "",
    roleName: "",
    roleCode: "",
    isActive: true,
    permissionIdList: {},
  });
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [rolesPermissions, setRolesPermissions] = useState([]);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [filterOriginalRoleData, setFilterOriginalRoleData] = useState([]);
  const [disabledToggles, setDisabledToggles] = useState({});
 
  const handleClose = () => {
    setLgShow(false);
    setEditRoleData(null);
    setFormInput({
      roleId: "",
      roleName: "",
      roleCode: "",
      permissionIdList: [],
    });
    setSelectedPermissions([]);
    setFormSubmitted(false);
    setToggleState('')
  };
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    const alphanumericRegex = /^[a-zA-Z0-9\s]*$/;
    if (value === "" || alphanumericRegex.test(value)) {
      setFormInput({ ...formInput, [name]: value });
    }
  };
 
  // Function to handle permission change
  const handlePermissionChange = (permissionId) => {
    // Toggle selected/unselected permissions
    const updatedPermissions = selectedPermissions.includes(permissionId)
      ? selectedPermissions.filter((id) => id !== permissionId)
      : [...selectedPermissions, permissionId];
    setSelectedPermissions(updatedPermissions);
 
    // Update disabled state for toggles based on selected permissions
    setDisabledToggles((prev) => ({
      ...prev,
      [permissionId]: !selectedPermissions.includes(permissionId),
    }));
 
    // Update toggle state based on selected permissions
    setToggleState((prevState) => ({
      ...prevState,
      [permissionId]: selectedPermissions.includes(permissionId) ? "enabled" : "active",
    }));
 
    // Automatically set the circle (toggle switch) to "active" when checkbox is clicked
    setToggleState((prevState) => ({
      ...prevState,
      [permissionId]: "active",
    }));
  };
 
  const handleToggleChange = (permissionId) => {
    setToggleState((prevState) => ({
      ...prevState,
      [permissionId]:
        prevState[permissionId] === "active" ? "enabled" : "active",
    }));
  };
 
  // Function to determine the color based on toggle state
  const getToggleColor = (permissionId) => {
    if (!selectedPermissions.includes(permissionId)) {
      return "grey";
    }
    switch (toggleState[permissionId]) {
      case "active":
        return "red";
      case "enabled":
        return "green";
      default:
        return "grey";
    }
  };
  const handleEdit = (permissionId) => {
    // Handle edit functionality here
    console.log(`Edit permission with ID: ${permissionId}`);
  };
  const handleEditRole = async (selectedRole) => {
    setIsOptionsLoading(true);
 
    try {
      const response = await getRoleById(selectedRole.roleId);
      if (response) {
        // Update state based on fetched role data
        setLgShow(true);
        setcurrentMode("edit");
        setEditRoleData(response.data || {});
        const permissionIdArray = response.data.map((item) => item.permissionId);
        const permissionIdMapping = response.data.map((item) => item.roleToPermissionMappingId);
        // setEditRoleData(permissionIdMapping)
        setEditRoleData(permissionIdMapping)
        setFormInput({
          ...formInput,
          roleId: selectedRole.roleId,
          roleName: selectedRole.roleName,
          roleCode: selectedRole.roleCode,
          isActive: selectedRole.isActive,
          permissionIdList: permissionIdArray,
        });
        setSelectedPermissions(permissionIdArray);
        // Update toggleState based on selected permissions
        const initialToggleState = {};
        response.data.forEach((permission) => {
          initialToggleState[permission.permissionId] = permission.canWrite ? "enabled" : "active";
        });
        setToggleState(initialToggleState);
      } else {
        console.error("Role details not found");
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 404) {
          // Handle 404 status code errors
          const errorMessage = data.message;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
        // if (error.response && error.response.status === 404) {
        //   const { data } = error.response;
        //   if (status === 404) {
        //     // Handle 409 status code errors
        //     const errorMessage = data;
        //     toast.error(errorMessage, {
        //       position: "top-right",
        //       autoClose: 5000,
        //       hideProgressBar: false,
        //     });
        //   }
        //   // If the error is 404 (Not Found), still set lgShow to true to open the modal
        setLgShow(true);
        setcurrentMode("edit");
        setEditRoleData({});
        setFormInput({
          ...formInput,
          roleId: selectedRole.roleId,
          roleName: selectedRole.roleName,
          roleCode: selectedRole.roleCode,
          isActive: selectedRole.isActive,
          permissionIdList: [],
        });
        setSelectedPermissions([]);
      }
    } finally {
      setIsOptionsLoading(false);
    }
  };
 
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setFormSubmitted(true);
 
      if (!formInput.roleCode || !formInput.roleName) {

        return;
      }
 
      if (selectedPermissions.length === 0) {
        toast.error("Please select at least one permission", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
        return;
      }
  
      let requestData;
      if (currentMode === "create") {
        const permissions = {};
        selectedPermissions.forEach((permissionId) => {
          permissions[permissionId] = toggleState[permissionId] === "enabled";
        });
 
        requestData = {
          roleName: formInput.roleName,
          roleCode: formInput.roleCode,
          permissions: permissions,
          isActive: formInput.isActive,
        };
 
        await CreateRoleDetails(requestData);
        toast.success("Role Added Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
        });
        setSelectedPermissions([]);
 
      } else if (currentMode === "edit") {
        const permissionsList = selectedPermissions.map((permissionId, index) => ({
          roleToPermissionId: editRoleData[index] || 0,
          permissionId: permissionId,
          canWrite: toggleState[permissionId] === "enabled",
        }));
 
        requestData = {
          roleName: formInput.roleName,
          roleCode: formInput.roleCode,
          permissions: permissionsList,
          isActive: formInput.isActive,
        };
 
        await UpdateRoles(formInput.roleId, requestData);
        toast.success("Role Updated Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
        });
      }
 
      getAllRoles();
      setFormInput({});
      setSelectedPermissions([]);
      setLgShow(false);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          toast.error(data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 409 || status === 404) {
          toast.error(data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    } finally {
      setIsOptionsLoading(false);
    }
  };
 
 
  const handleShow = () => {
    setLgShow(true);
    setcurrentMode("create");
    setFormInput({
      roleId: "",
      roleName: "",
      roleCode: "",
      isActive: true,
      permissionIdList: [],
    });
    setSelectedPermissions([]);
    setToggleState({});
    setIsOptionsLoading(true);
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
  };
 
  const getAllRoles = async () => {
    try {
      const response = await AllRoles();
 
      const roleDataResponse = response.map((role) => ({
        ...role,
        status: role.isActive ? "Active" : "InActive",
      }));
 
      const sortedRoleData = roleDataResponse.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
 
      setRolesData(sortedRoleData);
      setFilterOriginalRoleData(sortedRoleData)
      // console.log(roleDataResponse, 'roleDataResponse')
      setIsOptionsLoading(false);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };
 
  useEffect(() => {
    getAllRoles();
  }, []);
 
  useEffect(() => {
    const getAllRolesPermissions = async () => {
      try {
        const rolePermissions = await AllRolesPermissions();
        setRolesPermissions(rolePermissions);
      } catch (error) {
        console.error("Error fetching roles permissions:", error);
      }
    };
 
    getAllRolesPermissions();
  }, []);
 
  const groupedPermissions = rolesPermissions.reduce((acc, permission) => {
    if (!acc[permission.pageCategoryName]) {
      acc[permission.pageCategoryName] = [];
    }
    acc[permission.pageCategoryName].push(permission);
    return acc;
  }, {});
 
  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      // [name]: value === "true" ? true : false,
      [name]: value === "true",
    }));
  };
 
  let storedPermissions =localStorage.getItem('permissionId')
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  let canWriteValue = null;
 
  // Convert storedPermissions to a number (if needed)
  // Use this page's own permissionId so the Add/Update buttons don't depend on
  // the shared localStorage "permissionId" (which caused them to sometimes hide).
  storedPermissions = 23;
 
  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionId === storedPermissions);
 
  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }
 
  const searchRoleHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalRoleData.filter(item => item?.roleName?.toLowerCase()?.includes(term) || item?.roleCode?.toLowerCase()?.includes(term))
    setRolesData(data);
  }
 
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      placeholder="Search Role or Role Code"
                      type="text"
                      className="form-control bg-white"
                      onInput={searchRoleHandler}
                    />
                  </div>
                </div>
                <div className="col-md-3 d-flex justify-content-end">
                  <div >
                    {canWriteValue === true ?
                      <button
                        className="button-container ms-auto mr-1"
                        onClick={handleShow}
                      >
                        <i className="fa-solid fa-plus me-1 icon-container"></i>
                        {t("Add Role")}
                      </button>
                      : ''}
                  </div>           
                  <div >
                <ExportRolesExcel filteredData={rolesData}/>
                  </div>   
                </div>
                
              </div>
              <div className="card">
                <div className="card-body p-3">
                  <div className="top-header">
                    <span>{t("Roles")}</span>
                  </div>
                  {isOptionsLoading?<TableSkeleton />: <TableComponent
                    DataFetchURL={rolesData}
                    headers={headers}
                    editData={handleEditRole}
                    filterFunction={(data) =>
                      data.filter(
                        (item) => item.status === 1 || item.status === 0
                      )
                    }
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {currentMode === "edit" ? "Edit" : "Add"} Role
          </Modal.Title>
          <i
            className="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="row">
              {/* {currentMode === "edit" ? */}
              <div className="col-md-4" style={{ display: "none" }}>
                <div className="form-group ">
                  <label className="form-label">Role ID </label>
                  <input
                    type="text"
                    placeholder="Enter Role Id"
                    className="form-control"
                    name="roleId"
                    value={formInput.roleId}
                    // onChange={handleChange}
                    readOnly
                    disabled={!canWriteValue}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group ">
                  <label className="form-label">Role Code {" "}
                  <span style={{ color: "#EC1117" }}> *</span></label>
                  <input
                    type="text"
                    placeholder="Enter Role Code"
                    // className="form-control"
                    className={`form-control ${
                      formInput.roleCode || !formSubmitted ? "" : "input-error"
                    }`}
                    name="roleCode"
                    value={formInput.roleCode}
                    // onChange={handleChange}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const sanitizedValue = inputValue.replace(
                        /[^a-zA-Z0-9]/g,
                        ""
                      );
                      setFormInput({
                        ...formInput,
                        roleCode: sanitizedValue,
                      });
                    }}
                    maxLength={8}
                    disabled={!canWriteValue}
                  />
                  {!formInput.roleCode && formSubmitted && (
                    <div className="required-message small">
                      Role Code is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group ">
                  <label className="form-label">Role Name {" "}
                  <span style={{ color: "#EC1117" }}> *</span></label>
                  <input
                    type="text"
                    placeholder="Enter Role Name"
                    // className="form-control"
                    className={`form-control ${
                      formInput.roleName || !formSubmitted ? "" : "input-error"
                    }`}
                    name="roleName"
                    value={formInput.roleName}
                    onChange={handleChange}
                    maxLength={12}
                    disabled={!canWriteValue}
                  />
                  {!formInput.roleName && formSubmitted && (
                    <div className="required-message small">
                      Role Name is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4"></div>
              <div className="col-md-4">
                <label className="form-label">
                  Status <span style={{ color: "#EC1117" }}> *</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="activeRadio"
                      // {...register('isActive')}
                      value="true"
                      checked={formInput.isActive === true}
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="inactiveRadio"
                      // {...register('isActive')}
                      value="false"
                      checked={formInput.isActive === false}
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="inactiveRadio">
                      Inactive
                    </label>
                  </div>
                </div>
              </div>
              {/* Permissions checkboxes */}
              {Object.keys(groupedPermissions).map((pageCategoryName) => (
                <div key={pageCategoryName}>
                  <h3 className="edit_h3">{pageCategoryName}</h3>
                  <div className="row g-3 mb-3">
                    {groupedPermissions[pageCategoryName].map((permission) => (
                      <div className="col-md-4" key={permission.permissionId}>
                        <div className="card-header_organisation mb-0">
                          <div className="form-group">
                            <div className="custom-control custom-checkbox custom-checkbox-info">
                              <input
                                type="checkbox"
                                className={`custom-control-input ${
                                  isProd ? 'custom-checkbox-info' : ''
                                }`}
                                id={`permission-${permission.permissionId}`}
                                name={`permission-${permission.permissionId}`}
                                value={permission.permissionId}
                                onChange={() =>
                                  handlePermissionChange(
                                    permission.permissionId
                                  )
                                }
                                checked={selectedPermissions.includes(
                                  permission.permissionId
                                )}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`permission-${permission.permissionId}`}
                              >
                                {permission.permissionName  }
                              </label>
                              {permission?.isEditVisible && <div style={{width: 70, flexShrink: 0}} className="zone-container with-box-sizing d-flex justify-content-end">
                                <span
                                  className="edit-text"
                                  onClick={() =>
                                    handleEdit(permission.permissionId)
                                  }
                                >
                                  Edit
                                </span>
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    checked={
                                      toggleState[permission.permissionId] ===
                                        "active" ||
                                      toggleState[permission.permissionId] ===
                                        "enabled"
                                    }
                                    onChange={() =>
                                      handleToggleChange(
                                        permission.permissionId
                                      )
                                    }
                                    disabled={
                                      !selectedPermissions.includes(
                                        permission.permissionId
                                      )
                                    }
                                  />
                                  <span className="slider round">
                                    <span
                                      className={`circle ${
                                        toggleState[permission.permissionId]
                                      } ${isProd ? 'circle-ghmc' : 'circle-swm'}`}
                                      style={{
                                        backgroundColor: getToggleColor(
                                          toggleState[permission.permissionId],
                                          !selectedPermissions.includes(
                                            permission.permissionId
                                          )
                                        ),
                                      }}
                                    ></span>
                                  </span>
                                </label>
                              </div>}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <div className="modal-footer d-flex justify-content-center">
            {/* {canWriteValue === true ? */}
              <button type="submit" className="deployment-button">
                <i className="fa-solid fa-check done-container"></i>
                {currentMode === "edit" ? "Update" : "Save"}
              </button>
              {/* :""} */}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};
 
export default withTranslation()(RoleCreation);